import { ChatBubbleOutline, InputOutlined } from '@mui/icons-material'
import { Box, Button, IconButton, Typography } from '@mui/material'
import { useChatStore } from '../../stores/useChatStore'
import { useCallStore } from '../../stores/useCallStore'
import { useChatActions } from '../../hooks/useChatActions'
import { useConversationManagement } from '../../hooks/useConversationManagement'
import { useShallow } from 'zustand/react/shallow'

const ChatHeader = () => {
  const { messages, selectedConversation } = useChatStore(
    useShallow(state => ({
      messages: state.messages,
      selectedConversation: state.selectedConversation,
    }))
  )
  const { isCallActive, showContinueInChat } = useCallStore(
    useShallow(state => ({
      isCallActive: state.isCallActive,
      showContinueInChat: state.showContinueInChat,
    }))
  )
  const { exportChatToCSV } = useChatActions()
  const { handleContinueInChat } = useConversationManagement()

  const handleExportCSV = () => {
    exportChatToCSV(messages, selectedConversation)
  }

  const onContinueInChat = async () => {
    await handleContinueInChat()
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: '12px 20px',
        backgroundColor: 'transparent',
      }}
    >
      <Typography
        variant="h6"
        fontWeight={700}
        sx={{ color: 'var(--brand-500)', letterSpacing: '0.3px' }}
      >
        FRANCA AI
      </Typography>

      <Box sx={{ marginLeft: 'auto', display: 'flex', gap: 1, alignItems: 'center' }}>
        {messages?.length > 0 && (
          <IconButton
            onClick={handleExportCSV}
            title="Esporta chat (CSV)"
            sx={{
              width: 44,
              height: 44,
              backgroundColor: '#fff',
              borderRadius: 2,
              boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
              transition: 'all 0.2s',
              '&:hover': {
                boxShadow: '0 3px 10px rgba(0,0,0,0.18)',
                backgroundColor: '#fafafa',
              },
            }}
          >
            <InputOutlined sx={{ fontSize: 22, color: '#6b7280' }} />
          </IconButton>
        )}

        {/* Continue in Chat Button */}
        {showContinueInChat && !isCallActive && (
          <Button
            onClick={onContinueInChat}
            variant="contained"
            startIcon={<ChatBubbleOutline />}
            title="Continua nella chat"
            sx={{
              backgroundColor: '#10b981',
              color: 'white',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '20px',
              px: 2,
              py: 1,
              boxShadow: '0 2px 8px rgba(16,185,129,0.3)',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                backgroundColor: '#059669',
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 12px rgba(16,185,129,0.4)',
              },
            }}
          >
            Continua nella Chat
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default ChatHeader
